module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/media-74ca9a3a8e3e30fd7f6489eb817c11b2.svg";